import axios from "axios";
import { BASE_URL } from "../../_constants/urlConstants";
import { getUUID } from "../../_utils/generalUtils";
import raiseError from "../raiseError";
import qs from "qs";
import { QMS } from "../../_constants/actionConstants";

const logError = (e) => console.error("ProDMS/QMS: Request failed with error:", e);

const qmsTeamMemberRoleActions = {
  getAll: () => async (dispatch) => {
    dispatch({ type: QMS.TEAM_MEMBER_ROLE.FETCH_ALL });
    const apiEndpoint = BASE_URL + "/api/qms/MemberRole";
    try {
      const res = await axios.get(apiEndpoint);
      dispatch({
        type: QMS.TEAM_MEMBER_ROLE.FETCH_ALL_FULFILLED,
        qmsTeamMemberRoles: res.data,
      });
    } catch (e) {
      dispatch({ type: QMS.TEAM_MEMBER_ROLE.FETCH_ALL_REJECTED });
      logError(e);
    }
  },
};

export default qmsTeamMemberRoleActions;
